A state of the application or position.
